// extracted by mini-css-extract-plugin
export var star = "pageLiked-module--star--ayK3D";
export var hand = "pageLiked-module--hand--UnkW-";
export var face = "pageLiked-module--face--JxDLh";
export var heart = "pageLiked-module--heart--hET8z";